export enum RestApiState {
    Idle,
    Pending,
    Success,
    ServerError,
    Restricted,
    Unknown,
    BadRequest
}